
export const getDisplayName = (user, fallback = "there") => {
    if (!user) return fallback;
    return (
        (user.name && user.name.trim()) ||
        (user.username && user.username.trim()) ||
        (user.email && user.email.trim()) ||
        fallback
    );
};

export const getInitials = (user, fallback = "A") => {
    if (!user) return fallback;
    const display = getDisplayName(user, "");
    if (!display) return fallback;

    // If it's an email, use the part before the @
    const source = display.includes("@") ? display.split("@")[0] : display;

    return source
        .split(/[\s._-]+/)
        .filter(Boolean)
        .map((w) => w[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
};

export const formatDate = (iso, { withTime = false, long = false } = {}) => {
    if (!iso) return "—";

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "—";

    const day = date.getDate();
    const month = date.toLocaleString("en-GB", {
        month: long ? "long" : "short",
    });
    const year = date.getFullYear();

    const datePart = `${day} ${month} ${year}`;

    if (!withTime) return datePart;

    const timePart = date.toLocaleString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${datePart}, ${timePart}`;
};